import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyAgentPoradnik() {
  return <ArticleLayout article={articlesBySlug['kakobuy-agent-zakupowy-poradnik']} />;
}